import React, { useEffect, useMemo } from "react";
import Slider from "src/components/slider";
import styles from "./delete.module.scss";
import { Conversation } from "src/types/conversations";
import Button from "src/components/button";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { deleteConversation } from "src/redux/actions/conversation";
import { RootState } from "src/redux/store";

interface IDelete {
  show: boolean;
  onClose: () => void;
  conversation: Conversation;
}

const Delete: React.FC<IDelete> = ({ conversation, show, onClose }) => {  
  const dispatch = useDispatch();
  const { deleted, deleting } = useSelector((state: RootState) =>
    _.get(state, `conversations.delete.${conversation.id}`,{
      deleted: false,
      deleting: false,
    }),
  );
  
  const handleDelete = () => {
    dispatch(
      deleteConversation({
        id: conversation.id!,
      }),
    );
  };

  useEffect(() => {
    if (deleted) {
      onClose();
    }
  }, [deleted, deleting]);

  const title = useMemo(() => {
    if (_.get(conversation, "collection")) {
      return _.get(conversation, "collection.name", "");
    } else if (_.get(conversation, "subject")) {
      return _.get(conversation, "subject");
    } else {
      return "No Subject";
    }
  }, [conversation.subject]);

  return (
    <Slider.Dialog show={show} width="25rem" onClose={onClose}>
      <Slider.Header className={styles.header}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>delete</div>
          <div className={styles.subtitle}>{title}</div>
        </div>
        <div className={styles.close} onClick={onClose}>
          <i className="icon-close" />
        </div>
      </Slider.Header>

      <Slider.Body className={styles.body}>
        <p className={styles.content}>
          Are you sure you&apos;d like to permanently delete this share?
        </p>
      </Slider.Body>

      <Slider.Actions>
        <Button
          variant="primary"
          icon="paperflite-tick"
          disabled={deleting}
          onClick={handleDelete}
          text={deleting ? "deleting..." : "confirm"}
        />
        <Button text="cancel" onClick={onClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default Delete;
